<div class="modal-header">
  <h4 class="modal-title pull-left mb-0">Notifications</h4>
  <button type="button" class="btn-close close pull-right fs-12" aria-label="Close" (click)="cancel()">
    <span aria-hidden="true" class="visually-hidden font-weight-light">&times;</span>
  </button>
</div>

<div class="modal-body">
  <app-notification-data-card-items
    [notifications]="notifications"
    [isLoading]="isLoading"></app-notification-data-card-items>
</div>

<div class="modal-footer text-center">
  <button type="button" class="btn btn-outline-danger" (click)="cancel()">Close</button>
</div>
